import React from 'react';
import styled from 'styled-components';

const Careers = () => {
  return (
    <Wrapper>
      <div className="content-box">
        <h2>Careers at BakPoket</h2>

        <section className="job-section">
          <h4>Support Executive</h4>
          <h5>1. Customer Interaction</h5>
          <ul>
            <li>Respond to customer queries via phone, email, chat, or ticketing systems.</li>
            <li>Provide accurate information and troubleshooting steps for issues reported.</li>
            <li>Maintain a positive and empathetic attitude toward customers.</li>
          </ul>

          <h5>2. Feedback & Reporting</h5>
          <ul>
            <li>Record customer feedback and pain points.</li>
            <li>Create regular reports on recurring issues or customer satisfaction.</li>
            <li>Suggest improvements to workflows or FAQs.</li>
          </ul>

          <h5>3. Collaboration</h5>
          <ul>
            <li>Coordinate with internal departments (sales, tech, accounts) to resolve issues.</li>
            <li>Maintain communication loops with relevant stakeholders.</li>
          </ul>
        </section>

        <section className="job-section">
          <h4>Merchant Relationship Executive (MRE)</h4>
          <p>
            The Merchant Relationship Executive is responsible for onboarding, supporting, and managing relationships with merchants/vendors. They act as the primary point of contact between the company and merchants, ensuring smooth operations, resolving issues, and helping merchants maximize their engagement with the platform.
          </p>

          <h5>1. Merchant Onboarding</h5>
          <ul>
            <li>Identify and onboard new merchants to the platform.</li>
            <li>Assist merchants with documentation, account setup, and product/service listing.</li>
            <li>Provide training on how to use the company’s tools or dashboard.</li>
          </ul>

          <h5>2. Issue Resolution</h5>
          <ul>
            <li>Handle operational or technical issues faced by merchants.</li>
            <li>Coordinate with internal teams (support, tech, logistics) for resolution.</li>
            <li>Ensure timely follow-up on open issues.</li>
          </ul>

          <h5>3. Sales & Growth Support</h5>
          <ul>
            <li>Encourage merchants to participate in campaigns, promotions, or new feature adoption.</li>
            <li>Upsell value-added services (ads, premium listings, etc.).</li>
            <li>Work towards increasing merchant sales and engagement.</li>
          </ul>
        </section>

        <section className="job-section">
          <h4>User Relationship Executive (URE)</h4>
          <p>
            The User Relationship Executive is responsible for building and maintaining positive relationships with users/customers by providing support, guidance, and a high-quality experience. The goal is to increase user satisfaction, retention, and platform trust.
          </p>

          <h5>1. User Support & Engagement</h5>
          <ul>
            <li>Interact with users via phone, email, chat, or in-app support to resolve queries.</li>
            <li>Provide step-by-step assistance on using the product or service.</li>
          </ul>

          <h5>2. Documentation & Reporting</h5>
          <ul>
            <li>Log interactions and updates in CRM or support tools.</li>
            <li>Maintain accurate records of user issues, feedback, and behavior trends.</li>
            <li>Provide regular reports on user satisfaction metrics and pain points.</li>
          </ul>

          <h5>3. Issue Resolution</h5>
          <ul>
            <li>Troubleshoot problems and ensure timely resolution.</li>
            <li>Escalate complex issues to relevant departments (technical, billing, etc.).</li>
            <li>Follow up proactively to ensure the issue is completely resolved.</li>
          </ul>
        </section>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  background-color: #e6e6e6;
  padding: 40px 16px;
  display: flex;
  justify-content: center;

  .content-box {
    width: 100%;
    max-width: 1200px;
    background-color: #ffffff;
    padding: 40px;
    border-radius: 10px;
    line-height: 1.7;
    color: #333;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    font-size: 1rem;
  }

  h2 {
    margin-bottom: 30px;
    font-size: 2rem;
    font-weight: 600;
    text-align: center;
    color: #2a4157;
  }

  h4 {
    margin-top: 30px;
    margin-bottom: 10px;
    color: #ef4766;
    font-size: 1.4rem;
  }

  h5 {
    margin-top: 20px;
    margin-bottom: 10px;
    font-size: 1.1rem;
    color: #444;
  }

  ul {
    margin-left: 20px;
    padding-left: 20px;
    list-style: disc;
  }

  li {
    margin-bottom: 10px;
  }

  .job-section {
    margin-bottom: 40px;
    border-top: 1px solid #ddd;
    padding-top: 20px;
  }

  @media (max-width: 768px) {
    .content-box {
      padding: 25px;
      font-size: 0.95rem;
    }

    h2 {
      font-size: 1.6rem;
    }

    h4 {
      font-size: 1.2rem;
    }

    h5 {
      font-size: 1rem;
    }
  }

  @media (max-width: 480px) {
    padding: 10px 16px 40px;

    .content-box {
      padding: 20px;
      font-size: 0.9rem;
    }

    h2 {
      font-size: 1.4rem;
    }

    h4 {
      font-size: 1.1rem;
    }

    h5 {
      font-size: 0.95rem;
    }
  }
`;

export default Careers;
